module.exports = __webpack_public_path__ + "img/3.04ad2849.png";